// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buybox-promotion-row[data-v-2642b1d8]{background:#0c131e}", ""]);
// Exports
module.exports = exports;
